(() => {
  const forgotPasswordOpener = document.querySelectorAll(".js-log-in__forgot-password");
  const forgotPassswordWrapper = document.querySelectorAll(".js-main-menu__reset-password-form");

  const forgorPasswordStatus = document.querySelectorAll(".js-forgor-password-status");
  const forgorPasswordPresenter = document.querySelectorAll(".recover-password-success-presenter");

  if (forgorPasswordStatus) {
    Array.from(forgorPasswordStatus).forEach((status, index) => {
      Array.from(forgorPasswordPresenter)[index].innerHTML = status.innerHTML;
    });
  }

  Array.from(forgotPasswordOpener).forEach((opener, index) => {
    opener.addEventListener("click", () => {
      Array.from(forgotPassswordWrapper)[index].classList.remove("hidden");
    });
  });
})();
